import { useContext, useEffect } from "react";
import LinearProgress from "@mui/material/LinearProgress";
import axios from "axios";
import { JobContext } from "../context/JobContext";
import { useState } from "react";
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import { Check, X } from "react-feather";

const panelStyle = {
    position: "fixed",
    top: "70px",
    right: "20px",
    width: "350px",
    background: "rgb(255 255 255)",
    padding: "10px 15px 10px 15px",
    borderRadius: "8px",
    boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
    zIndex: 9999
};

const panelTitle = {
    fontSize: "16px",
    margin: "0 0 12px 0",
    fontWeight: "600",
    color: "#343434"
}

const statsContainer = {
    marginTop: "8px",
    fontSize: "13px",
    display: "grid",
    gridTemplateColumns: "1.3fr 1fr"
};

const titleTotal = {
    color: "#343434",
    fontSize: "12px",
};

const titleRemaining = {
    color: "#343434",
    fontSize: "12px",
    textAlign: "right"
};

const titleSuccess = {
    color: "#2FA42B",
    fontSize: "13px",
    fontWeight: "500",
    padding: "6px 0 0 0",
    borderTop: "1px solid #f0f0f0",
    margin: "8px 0 0 0",
    textAlign: "center"
};

const titleFailed = {
    color: "#B82116",
    fontSize: "13px",
    fontWeight: "500",
    padding: "6px 0 0 0",
    borderTop: "1px solid #f0f0f0",
    borderLeft: "1px solid #f0f0f0",
    margin: "8px 0 0 0",
    textAlign: "center"
};

const titleSuccessIcon = {
    width: "16px",
    height: "16px",
    marginRight: "2px"
};

function GlobalProgressBar() {

    const [showProgressBar, setShowProgressBar] = useState(true);

    const [showSuccessMsg, setShowSuccessMsg] = useState(false);
    const [successMsg, setSuccessMsg] = useState('');
    const [successData, setSuccessData] = useState(null);

    const { jobId, setJobId, progress, setProgress, jobData, setJobData } = useContext(JobContext);


    useEffect(() => {
        console.log('jobId');
        console.log(jobId);
        if (!jobId) return;

        const interval = setInterval(async () => {

            console.log(progress);

            await axios.get(process.env.REACT_APP_DEVICE_API_URL + 'v1/task-progress/' + jobId).then(response => {
                console.log(response);

                setProgress(response.data.data.progress);

                setJobData(response.data.data);

                if (response.data.data.progress >= 100) {
                    clearInterval(interval);

                    setShowProgressBar(false);

                    console.log(response.data.data);

                    setSuccessData(response.data.data);

                    let sucMsg = '';

                    if (response.data.data?.failed > 0) {
                        sucMsg = '<p>' + response.data.data.success_msg + '</p><div><strong>Failed Locks:</strong></div><div class="ProgressbarLockListSec"><ol>';
                        for (let n in response.data.data?.failed_devices) {
                            sucMsg += '<li>' + response.data.data?.failed_devices[n]?.name + '</li>';
                        }
                        sucMsg += '</ol></div>';
                    } else {
                        sucMsg = '<p>' + response.data.data.success_msg + '.</p>';
                    }
                    setSuccessMsg(sucMsg);
                    setShowSuccessMsg(true);

                    /*setSnackbarOpen(true);
                    setSnackbarMsg(response.data.data.success_msg);
                    setShowProgressBar(false);

                    setTimeout(() => {
                        setShowProgressBar(true);
                        setSnackbarOpen(false);
                        setJobId(null);
                    }, 5000)*/

                }

            }).catch(error => {
                console.log(error);
                clearInterval(interval);

                setJobId(null);
            });

        }, 2000);

        return () => clearInterval(interval);

    }, [jobId]);

    const closePopups = () => {
        setShowSuccessMsg(false);
        setJobId(null);
        setShowProgressBar(true);
    }

    if (!jobId) return null;

    return (<>
        {showProgressBar && <div style={panelStyle}>
            <div style={panelTitle}>{jobData?.title}</div>

            <LinearProgress variant="determinate" value={progress} className="CustomStatusBar" />

            <div style={statsContainer}>
                <div style={titleTotal}>{jobData?.total} Devices Processing</div>
                <div style={titleRemaining}>{jobData?.remaining} Remaining</div>
                <div style={titleSuccess}><Check style={titleSuccessIcon} /> {jobData?.success} Added Successfully</div>
                <div style={titleFailed}><X style={titleSuccessIcon} /> {jobData?.failed} Failed</div>
            </div>
        </div>}


        <Dialog
            open={showSuccessMsg}
            fullWidth
            maxWidth="xs"
            onClose={(e) => closePopups()}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="NewPopUp"
        >
            <DialogTitle id="alert-dialog-title">{successData?.title}<button onClick={(e) => closePopups()}><X /></button></DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    <div className="ModalFormGroup Confirm">
                        <label className="PopupBodyText" dangerouslySetInnerHTML={{ __html: successMsg }}></label>
                    </div>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <button onClick={(e) => closePopups()} className="OKPopupBU">OK</button>
            </DialogActions>
        </Dialog>
    </>);
}

export default GlobalProgressBar;